module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('flights-view', {
    attrs: {
      "flights": _vm.flights
    }
  }), _vm._v(" "), _vm._l((_vm.components), function(component) {
    return (component.show) ? _c('component-view', {
      key: component.id,
      attrs: {
        "component": component
      }
    }) : _vm._e()
  })], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Onderdelen worden opgehaald\r\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a6320c"}!./src/templates/reservations/component-list.html
// module id = 543
// module chunks = 1